const aboutMainWrap = () => import("@/views/main_wrap.vue");

const createAboutViewRoute = ({ path, name, component, aliases = [] }) => ({
    path,
    name,
    alias: aliases,
    component: aboutMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const aboutRoutes = [
    createAboutViewRoute({
        path: "/about/ceo-message",
        name: "Gsrab01",
        aliases: ["/gsrab01", "/about/gsrab01"],
        component: () => import("@/views/about/01/gsrab01.vue")
    }),
    createAboutViewRoute({
        path: "/about/company",
        name: "Gsrab02",
        aliases: ["/gsrab02", "/about/gsrab02"],
        component: () => import("@/views/about/02/gsrab02.vue")
    }),
    createAboutViewRoute({
        path: "/about/history",
        name: "Gsrab03",
        aliases: ["/gsrab03", "/about/gsrab03"],
        component: () => import("@/views/about/03/gsrab03.vue")
    }),
    createAboutViewRoute({
        path: "/about/awards",
        name: "Gsrab06",
        aliases: ["/gsrab06", "/about/gsrab06"],
        component: () => import("@/views/about/06/gsrab06.vue")
    }),
    createAboutViewRoute({
        path: "/about/ci-bi",
        name: "Gsrab04",
        aliases: ["/gsrab04", "/about/gsrab04"],
        component: () => import("@/views/about/04/gsrab04.vue")
    }),
    createAboutViewRoute({
        path: "/about/location",
        name: "Gsrab05",
        aliases: ["/gsrab05", "/about/gsrab05"],
        component: () => import("@/views/about/05/gsrab05.vue")
    })
];
